export function includes<T, U extends T>(arr: readonly U[], elem: U): elem is U {
    return arr.includes(elem);
}
